import { z } from 'zod';

const envSchema = z.object({
  VITE_APP_ENV: z.enum(['localhost', 'development', 'production']),
  VITE_APP_NAME: z.string().min(1),
  VITE_API_URL: z.string().url(),
  VITE_TOSS_CLIENT_KEY: z.string(),
  /** 자동결제(빌링) 상점 클라이언트 키. 단건 키와 상점(MID)이 다르다. */
  VITE_TOSS_BILLING_CLIENT_KEY: z.string(),
  VITE_CDN_BASE_URL: z.string().url(),
  /**
   * 기업콘솔(console-web) origin. `/business/console` 스텁이 여기로 넘긴다.
   * 세션 쿠키를 공유하려면 web 과 **같은 eTLD+1** 이어야 한다(BE COOKIE_DOMAIN).
   */
  VITE_CONSOLE_URL: z.string().url(),
  VITE_USE_MOCK: z.enum(['true', 'false']).optional(),
});

const parsed = envSchema.safeParse(import.meta.env);

if (!parsed.success) {
  const flat = parsed.error.flatten().fieldErrors;
  const details = Object.entries(flat)
  .map(([key, messages]) => `  - ${key}: ${messages?.join(', ')}`)
  .join('\n');

  // dev/prod 모두에서 명확히 식별 가능하도록 상세 출력
  console.error(
    `[env] 환경변수 검증 실패\n${details}\n` +
    `env/.env.[mode] 파일을 확인하세요. (현재 mode: ${import.meta.env.MODE})`,
  );

  throw new Error('Invalid environment variables');
}

export const env = parsed.data;
export type AppEnv = typeof env;